export default "__VITE_ASSET__CWt3081O__"